import ko from 'knockout';

export const isQuickAddOpen = ko.observable(false);
